import { useQuery } from "@tanstack/react-query";
import axiosInstance from "../../api/axiosInstance";

export default function useProfileAvatars() {
  return useQuery({
    queryKey: ["profileAvatars"],
    queryFn: async () => {
      const response = await axiosInstance.get("api/avatarlist");
      return response.data;
    },
    staleTime: Infinity,
    cacheTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
}
